// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__qJxFS","auth":"modal_auth__3Lssa","change_password":"modal_change_password__oEKx2"};